/**
 * Renders text content for a section panel.
 * Supports paragraphs, equations (KaTeX), and bullet lists.
 *
 * Handles both string and structured content (blocks).
 * Uses normalization helpers for consistent rendering.
 */

import EquationBlock from './EquationBlock';
import BulletList from './BulletList';
import {
  normalizeContentBlocks,
  normalizeTextBlock,
} from '../utils/renderSpecContent';

export default function SpecTextPanel({ panel }) {
  if (!panel) return null;

  const isStringBody = typeof panel.body === 'string';
  const bodyBlocks = isStringBody ? [] : normalizeContentBlocks(panel.body);
  const bullets = panel.bullets ?? [];

  return (
    <div className="specpageTextPanel">
      {panel.heading && (
        <h3 className="specpagePanelHeading">{panel.heading}</h3>
      )}

      {isStringBody && (
        <p className="specpageParagraph">
          {normalizeTextBlock(panel.body)}
        </p>
      )}

      {!isStringBody &&
        bodyBlocks.map((block, index) => {
          if (block.type === 'equation') {
            return <EquationBlock key={index} value={block.value} />;
          }

          return (
            <p
              key={index}
              className={`specpageParagraph ${block.tone === 'note' ? 'specpageParagraph--note' : ''}`}
              dangerouslySetInnerHTML={{ __html: block.value }}
            />
          );
        })}

      {bullets.length > 0 && <BulletList bullets={bullets} />}
    </div>
  );
}